import Button from '@talkdesk/cobalt-react-button'

const NavbarButton = ({ action, actionMessage }) => (
  <Button
    htmlType='button'
    onClick={() => action()}
    type='secondary'
    size='small'
  >
    {actionMessage}
  </Button>
)

export default NavbarButton
